var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmationModal',{attrs:{"bodyText":_vm.bodyText,"cancelText":_vm.numEligibleUsers ? 'cancel' : '',"continueText":_vm.numEligibleUsers ? 'unlock' : 'ok',"handleCancel":_vm.hideModal,"handleContinue":_vm.action,"headerText":"Unlock User Account"}})
}
var staticRenderFns = []

export { render, staticRenderFns }